import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../../hooks";
import { VirtualScenes } from "../../../../api";
import { Grid } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { hasText, htmlHasContent, hasItems } from "../guiaHelpers";
import "./Module5.scss";

const virtualScenesController = new VirtualScenes();

export function Module5({ refId }) {
  const module5 = "module_05";
  const { accessToken } = useAuth();
  const { t } = useTranslation("scenes");

  const [moduleData, setModuleData] = useState(null);
  const [imageCompetencyUrl, setImageCompetencyUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ✅ Obtener datos del módulo
  const fetchModuleData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await virtualScenesController.getVirtualScenesModeule(
        refId,
        accessToken,
        module5,
      );
      setModuleData(data.moduleData);

      // Obtener URL de la imagen si existe
      if (data.moduleData?.ModFiveImagecompetencies) {
        const imageData = await virtualScenesController.getRepoScene(
          data.moduleData.ModFiveImagecompetencies,
          accessToken,
        );
        setImageCompetencyUrl(imageData.url);
      }
    } catch (err) {
      console.error("Error al obtener datos del módulo:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [refId, accessToken, module5]);

  // ✅ Llamada inicial
  useEffect(() => {
    if (refId && accessToken) {
      fetchModuleData();
    }
  }, [refId, accessToken, fetchModuleData]);

  if (loading || error) return null;

  const competencies = moduleData?.ModFiveCompetencies;
  const hasImage = !!imageCompetencyUrl;
  const hasCompetencies = hasItems(competencies);

  if (!hasImage && !hasCompetencies) return null;

  return (
    <div className="module5-container">
      <h2>{t("guide.keyCompetencies")}</h2>
      <Grid stackable columns={2} className="module5-content">
        {/* Columna Izquierda - Imagen */}
        {hasImage && (
          <Grid.Column
            width={hasCompetencies ? 8 : 16}
            className="module5-image"
            verticalAlign="middle"
          >
            <img src={imageCompetencyUrl} alt="Competencias Clave" />
          </Grid.Column>
        )}

        {/* Columna Derecha - Contenido */}
        {hasCompetencies && (
          <Grid.Column
            width={hasImage ? 6 : 16}
            className="module5-competencies"
          >
            {competencies.map((competency) => (
              <div key={competency._id} className="competency-item">
                {hasText(competency.title) && <h4>{competency.title}</h4>}
                {htmlHasContent(competency.description) && (
                  <p
                    dangerouslySetInnerHTML={{ __html: competency.description }}
                  />
                )}
              </div>
            ))}
          </Grid.Column>
        )}
      </Grid>
    </div>
  );
}
